var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-tooltip",
    {
      attrs: {
        title: _vm.i18nRender("layouts.switch", [
          _vm.i18nRender("layouts.new.version"),
        ]),
      },
    },
    [
      _c(
        "a",
        {
          staticClass: "right-content__action",
          on: {
            click: function ($event) {
              _vm.visible = true
            },
          },
        },
        [
          _c("icon-font", { attrs: { type: "gb-icon-switch-circle" } }),
          _c(
            "a-modal",
            {
              attrs: {
                title: _vm.i18nRender("version-modal.title"),
                width: 620,
                dialogClass: "version-change-modal",
              },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c(
                "div",
                { staticClass: "tips" },
                [
                  _c("icon-font", { attrs: { type: "gb-icon-tishi" } }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.i18nRender("version-modal.tips")) + "，"),
                  ]),
                  _c(
                    "a",
                    { staticClass: "color", attrs: { href: "" } },
                    [
                      _vm._v("URL "),
                      _c("icon-font", {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "gb-icon-fenxiang_2" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" " + _vm._s(_vm.i18nRender("version-modal.info"))),
              _c("br"),
              _vm._v(
                " 1. " + _vm._s(_vm.i18nRender("version-modal.subInfo-1"))
              ),
              _c("br"),
              _vm._v(
                " 2. " + _vm._s(_vm.i18nRender("version-modal.subInfo-2"))
              ),
              _c("br"),
              _vm._v(
                " 3. " + _vm._s(_vm.i18nRender("version-modal.subInfo-3")) + " "
              ),
              _c(
                "a-row",
                {
                  attrs: {
                    slot: "footer",
                    type: "flex",
                    justify: "space-between",
                  },
                  slot: "footer",
                },
                [
                  _c(
                    "a-checkbox",
                    {
                      staticStyle: { float: "left" },
                      model: {
                        value: _vm.agreeToSwitchFlag,
                        callback: function ($$v) {
                          _vm.agreeToSwitchFlag = $$v
                        },
                        expression: "agreeToSwitchFlag",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.i18nRender("version-modal.footer")) +
                          " "
                      ),
                      _c(
                        "a-button",
                        {
                          staticClass: "color",
                          staticStyle: { padding: "0" },
                          attrs: { type: "link" },
                          on: { click: _vm.toDemo },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.i18nRender("version-modal.viewDemo"))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    [
                      _c(
                        "a-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.visible = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.i18nRender("form-modal.cancel")))]
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.submitLoading,
                            disabled: !_vm.agreeToSwitchFlag,
                          },
                          on: { click: _vm.handleOk },
                        },
                        [_vm._v(_vm._s(_vm.i18nRender("form-modal.submit")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }